module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/root//pet-intr_block.png?v=30b838dd";